module.exports = __webpack_public_path__ + "static/img/bg_activity1.b3e16f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/3/bg_activity1.png
// module id = xAEw
// module chunks = 1